var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "div",
            { attrs: { id: "table" } },
            [
              _c(
                "vxe-table",
                {
                  ref: "box",
                  attrs: {
                    "row-id": "id",
                    data: _vm.table,
                    align: "left",
                    "row-style": _vm.setRowClass,
                  },
                },
                [
                  _c("vxe-table-column", {
                    attrs: {
                      field: "strategy_id",
                      "show-overflow": "",
                      "min-width": "160",
                      title: "ID",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "memo",
                      "show-overflow": "",
                      "min-width": "120",
                      title: "备注",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "strategy_typeshow",
                      "show-overflow": "",
                      "min-width": "120",
                      title: "策略类型",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "product_name",
                      "show-overflow": "",
                      "min-width": "120",
                      title: "产品名称",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "success_total",
                      "show-overflow": "",
                      "min-width": "60",
                      title: "成功数",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "failed_total",
                      "show-overflow": "",
                      "min-width": "60",
                      title: "失败数",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "updated_at",
                      "show-overflow": "",
                      "min-width": "120",
                      title: "更新时间",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: { title: "操作", "min-width": "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (slotProps) {
                          return [
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn2",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleShowDetail(
                                          slotProps.row
                                        )
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("查看")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn2",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDelete(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("删除")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn2",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleExport(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("导出")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.total
            ? _c("v-pagination", {
                attrs: {
                  total: _vm.total,
                  name: "page-basic",
                  "is-show-total": "",
                  "is-change-size": "",
                  "is-input-page": "",
                  "current-page": _vm.currentPage,
                },
                on: {
                  "change-page": _vm.changePage,
                  "change-size": _vm.changeSize,
                },
              })
            : _vm._e(),
          _c("v-loading", {
            staticClass: "loading-box",
            attrs: {
              size: "L",
              visible: _vm.loading,
              text: "加载中...",
              name: "loading1",
            },
          }),
        ],
        1
      ),
      _c("Del", {
        ref: "Del",
        attrs: { showInputDialog: _vm.deleteVisible, row: _vm.selectRow },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.deleteVisible = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.deleteVisible = $event
          },
        },
      }),
      _c("Download", {
        ref: "Download",
        attrs: { showInputDialog: _vm.downloadVisible, row: _vm.selectRow },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.downloadVisible = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.downloadVisible = $event
          },
        },
      }),
      _c("DetailLog", {
        ref: "DetailLog",
        attrs: { showInputDialog: _vm.detailLogVisible, row: _vm.selectRow },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.detailLogVisible = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.detailLogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }